import { ADD_ADMIN_CONTENT_MANAGEMENT, ADD_ADMIN_CONTENT_MANAGEMENTS, UPDATE_CONTENT_MANAGEMENT } from './action';

// Initial State
const initialState = [];

const contentManagementReducer = (state = initialState, action) => {
     switch (action.type) {
          case ADD_ADMIN_CONTENT_MANAGEMENT: {
               const newContentManagement = [...state];
               newContentManagement.push(action.payload);
               return newContentManagement;
          }

          case ADD_ADMIN_CONTENT_MANAGEMENTS: {
               return action.payload;
          }

          case UPDATE_CONTENT_MANAGEMENT: {
               const contentManagementList = [...state];
               const newContentManagement = [];
               for (let i = 0; i < contentManagementList.length; i++) {
                    const contentManagement = contentManagementList[i];
                    if (contentManagement.id === action.payload.contentManagementId) {
                         newContentManagement.push(action.payload.contentManagement);
                         continue;
                    }
                    newContentManagement.push(contentManagement);
               }

               return newContentManagement;
          }

          default:
               return state;
     }
};

/* Selectors */

// Fetch ContentManagement by id
export const getContentManagementById = (state, con) => state.admin.contentManagements.filter((contentManagement) => contentManagement.id === con)[0];

export default contentManagementReducer;
